<template>
  <div class="contest__item__wrapper">
    <a
      :class="[
        'contest-item',
        'img-1by1',
      ]"
      v-bind:href="getRedirectURL(contest_details)"
      target="_blank"
      @click="onContestClick(contest_details, $event)"
      rel="nofollow"
      v-if="!contest_details.is_ad"
    >
      <div class="contest-thumbnail">
        <div class="img-box">
          <img
            :src="getImageUrl()"
            :data-src="getImageUrl()"
            alt
            class="lazy"
          />
        </div>
      </div>
      <div class="contest-info">
        <div class="info-wrap">
          <div class="info-section1">
            <div class="info-section-wrap">
              <div class="name">
                {{ translations.currency_symbol
                }}{{ convert_number(contest_details.tp) }}
              </div>
              <div class="price-detail">
                <span class="entry-fee"
                  >{{ translations.entry }} {{ translations.currency_symbol }}
                  {{ convert_number(contest_details.ef) }}</span
                >
                <span class="spot"
                  >{{ translations.spots }}:
                  {{ Number(contest_details.pc).toLocaleString("en-IN") }}</span
                >
              </div>
            </div>
            <div class="contest-rating">
              <span class="profit">{{ translations.approx_winnings }}</span>
              <span
                :class="[
                  'rating',
                  contest_details.ar < 0
                    ? 'loss'
                    : contest_details.ar !== 0
                    ? 'success'
                    : '',
                ]"
                >{{ translations.currency_symbol
                }}{{ convert_number(contest_details.mp) }}</span
              >
            </div>
          </div>
          <div class="info-section2">
            <span class="prize-pool"
              >{{ translations.top_prize }}: {{ translations.currency_symbol
              }}{{ convert_number(contest_details.hp) }}</span
            >
            <span class="winning">
              {{ getParticipantBracket(contest_details, translations.contestType) }}
            </span>
          </div>
        </div>
      </div>
    </a>
    <a
      class="contest-item img-1by1"
      v-else-if="checkIfAndroid()"
      @click="captureAdClick(contest_details)"
    >
      <img
        :src="contest_details.banner_image.replace(/{{source}}/, source)"
        style="width: 100%"
       alt=""/>
    </a>
  </div>
</template>
<script>
import { mobilecheck, addPagePropertiesToObject, sendTrackingData, convertNumber } from "../../../assets/js/common";
import { CFG_CONTEST_PARTICIPANT_BRACKETS, CFG_CUSTOM_CONTEST_REDIRECTS, CFG_UTM_PARAMS, CFG_TRACKING, CFG_PLATFORM_IMAGE_DOMAIN, CFG_MODULES } from "../../../assets/js/config";

export default {
  props: ["contest_details", "current_match"],
  data() {
    return {
      source: mobilecheck() ? "mweb" : "web",
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
  },
  methods: {
    getParticipantBracket(contest_details, outputText) {
      let bracket = CFG_CONTEST_PARTICIPANT_BRACKETS.find((cp) => (contest_details.pc >= cp.min && contest_details.pc <= cp.max));
      let bracketVal = (bracket && bracket.contestType) ? bracket.contestType : "-";
      return outputText.replace('{{type}}', bracketVal);
    },
    getRedirectURL(contest_details) {
      if (this.current_match.status !== 1) {
        return null;
      }
      if (CFG_CUSTOM_CONTEST_REDIRECTS[contest_details.pid]) {
        return CFG_CUSTOM_CONTEST_REDIRECTS[contest_details.pid]
          .redirect_url;
      }
      return contest_details.cu !== "" && this.addUtmParams(contest_details.cu);
    },
    addUtmParams: function(cu) {
      if (!cu) return cu;
      let url = new URL(cu);
      Object.keys(CFG_UTM_PARAMS).forEach((key) => {
        url.searchParams.set(key, CFG_UTM_PARAMS[key]);
      });
      return url;
    },
    onContestClick: function(contest_details, event) {
      //condition added if current match is expired one
      if (this.current_match.status !== 1) {
        event.stopPropagation();
        event.preventDefault();
        return false;
      }

      let { cid, pn } = contest_details;

      let toTrack = CFG_TRACKING["4"];
      toTrack.value = cid;
      toTrack.label = pn;
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
    convert_number: function(val) {
      return convertNumber(val);
    },
    getImageUrl: function() {
      return CFG_PLATFORM_IMAGE_DOMAIN + this.contest_details.pi;
    },
    checkIfAndroid() {
      return /Android/i.test(navigator.userAgent);
    },
    captureAdClick(details) {
      let toTrack = CFG_TRACKING["13"];
      toTrack.value = CFG_MODULES.GAME_PLAN.route;
      toTrack.label = "fg-app-download";
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
      window.open(details.redirect_to, "_blank");
    },
  },
};
</script>
